<div class="extra-narrow-content">
  <mat-card>
    <mat-card-content>
      <h1>Debug</h1>

      <p>App version: {{ appVersion }}</p>
      <p>Server version: {{ serverVersion }}</p>
    </mat-card-content>
  </mat-card>
</div>
